import React, { useState, useEffect, useReducer } from "react";
import { Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { TabName, WizzMode } from "./types";
import { getAttachments } from "./Tabs/General/Attachments";
import StructureTab, { validateStruture } from "./Tabs/Structure/Structure";
import Structure2Tab from "./Tabs/Structure/Structure2";
import GeneralTab, { validateGeneral } from "./Tabs/General/General";
import ModalCalculator from "./Calculator/Calculator";
import PaymentsTab from "./Tabs/Payments/Payments";
import ContractsTab from "./Tabs/Contracts/Contracts";
import SinonymslTab from "./Tabs/Sinonyms/Sinonyms";
import CurrencyTab from "./Tabs/Currency/Currency";
import ModalMessage from "./Modals/ModalMessage";
import ModalConfirm from "./Modals/ModalConfirm";
import AgenciesTab from "./Tabs/Agencies/Agencies";
import GroupsTab from "./Tabs/Groups/Groups";
import QuotesTab from "./Tabs/Quotes/Quotes";
import Navigation from "./Navigation";
import Header from "./Header/Header";
import TaxTab from "./Tabs/Tax/Tax";
import style from "./styles.module.scss";
import PortfoliosTab from "./Tabs/Portfolios/Portfolios";
import { Denominations } from "./Tabs/Denominations/Denominations";
import FundamentalsTab from "./Tabs/Fundamentals/Fundamentals";
import ModalLoadFromFile from "./Modals/ModalLoadFromFile";
import { toast } from "react-toastify";
const initialState = {
  AssetName: "",
  AssetTicker: "",
  AssetDescription: "",
  AssetIssuanceCurrency: null,
  AssetDefaultIdentifierValue: "",
  Attachments: [],
};

const Wizzard = ({ id, mode, role, Link, services, showToast, redirect, toggleOrder, initialTab, opsViewAccountName }) => {
  const [modals, setModals] = useState({
    confirm: { open: false },
    message: { open: false },
    calculator: { open: false },
  });
  const [saving, setSaving] = useState({});
  const [asset, setAsset] = useState(false);
  const [previousAsset, setPreviousAsset] = useState(false);
  const [errors, setErrors] = useState({});
  const [changedFiles, setChangedFiles] = useState({});
  const [tab, setTab] = useState(initialTab || TabName.General);
  const [fileModalOpen, setFileModalOpen] = useState(true);
  const [entities, setEntities] = useEntities({
    subAssetClasses: null,
    dataProviders: null,
    currencies: null,
    riskTypes: null,
    calendars: null,
  });

  useEffect(() => {
    services.assetEntities({}).then(({ subAssetClasses, dataProviders, riskTypes, calendars }) =>
      setEntities({
        subAssetClasses,
        dataProviders,
        riskTypes,
        calendars,
      })
    );

    services
      .currencies({})
      .then((res) => res.currencies)
      .then((currencies) => setEntities({ currencies }));
  }, []);

  useEffect(() => {
    if (mode) {
      if (id) {
        setAsset(false);

        services.assetInformation({ assetId: id }).then((res) => {
          setAsset(res.info);
          setPreviousAsset(res.info);
        });
      } else {
        setAsset(initialState);
        setPreviousAsset(initialState);
      }
    }
  }, [id]);

  useEffect(() => {
    if (asset.SubAssetClassId) {
      services
        .subAssetClass({ subAssetClassId: asset.SubAssetClassId })
        .then((res) => res.info)
        .then((info) =>
          setAsset({
            ...asset,
            SubAssetClassName: info.SubAssetClassName,
            SubAssetClassInfo: info,
          })
        );
    }
  }, [asset.SubAssetClassId]);

  const onChange = (newFields) => {
    setErrors({ ...errors, ...mapKeysToUndefined(newFields) });
    setAsset((prevAsset) => ({ ...prevAsset, ...newFields }));
    if (newFields && newFields.Synonyms)
      services.assetInformation({ assetId: id }).then((res) => {
        setAsset(res.info);
        setPreviousAsset(res.info);
      });
    if (asset.AssetIssuanceCurrency == null) {
      let currencyId = entities.currencies != null ? entities.currencies[0].currencyId : null;
      setAsset((prevAsset) => ({ ...prevAsset, AssetIssuanceCurrency: currencyId }));
    }
    if (newFields.AssetPhysicalDenomination == 1) {
      setAsset((prevAsset) => ({ ...prevAsset, AssetSheetSize: 1 }));
    }
  };

  const toggle = (name, props = {}) => {
    setModals({ ...modals, [name]: { open: !modals[name].open, ...props } });
  };

  const handleSave = (saveAndContinue) => {
    let forceGet = false;
    let nextErrors = {};
    let serviceHanlder;
    let wizzardIsValid = true;
    let generalIsValid = true;
    let strutureIsValid = true;

    const generalErrors = validateGeneral(asset);
    if (Object.keys(generalErrors).length != 0) {
      generalIsValid = false;
    }

    const structureErrors = validateStruture(asset);
    if (Object.keys(structureErrors).length != 0) {
      strutureIsValid = false;
    }

    if (mode == WizzMode.Edit) {
      serviceHanlder = services.update;
      nextErrors = { ...nextErrors, ...generalErrors, ...structureErrors };
      wizzardIsValid = generalIsValid && strutureIsValid;
    } else {
      serviceHanlder = services.create;
      nextErrors = { ...nextErrors, ...generalErrors };
      wizzardIsValid = generalIsValid;
    }

    const changedAttachments = getAttachments(changedFiles);
    const changedFields = asset;

    if (
      mode == WizzMode.Edit &&
      changedFields.AssetDefaultIdentifier != previousAsset.AssetDefaultIdentifier
    ) {
      forceGet = true;
    }

    setErrors(nextErrors);

    if (wizzardIsValid) {
      setSaving({
        saveAndContinue,
        save: !saveAndContinue,
      });

      serviceHanlder({
        info: changedFields,
        attachments: changedAttachments,
      })
        .then((res) => {
          setSaving({});
          if (!res) {
            toggle("message", { title: "Error", message: "Server error." });
            return;
          }

          const { result, assetId } = res;
          if (result.Code == 200) {
            setPreviousAsset(asset);
            showToast("Asset saved");

            if (mode == WizzMode.New) {
              setTimeout(() => {
                if (saveAndContinue) {
                  setAsset(false);
                  setChangedFiles({});
                  redirect({ page: "asset", assetId });
                } else {
                  redirect({ page: "assets" });
                }
              }, 500);
            }
            // first save after clone and change defaultDataProviderId
            if (forceGet) {
              services.assetInformation({ assetId: changedFields.AssetId }).then((res) => {
                setAsset(res.info);
                setPreviousAsset(res.info);
              });
            }
          } else {
            showToast(result.Description, false, true);
          }
        })
        .catch((error) => {
          toggle("message", {
            title: "Error",
            message: "Server error.",
          });
        });
    } else {
      showToast("Please fill in all required fields", true);
    }
  };

  const handleChangeFiles = (id, file) => {
    setChangedFiles({ ...changedFiles, [id]: file });
  };
  return (
    <div>
      <Header
        services={services}
        asset={asset}
        mode={mode}
        wizzToggle={toggle}
        Link={Link}
        toggleLoadFromXLS={() => setFileModalOpen(true)}
      />
      <Card className={style.card}>
        <CardHeader>
          <Navigation active={tab} toggle={setTab} mode={mode} role={role} asset={asset} />
        </CardHeader>
        <CardBody className={style.body}>
          {tab === TabName.General && (
            <GeneralTab
              mode={mode}
              fields={asset}
              previousFields={previousAsset}
              errors={errors}
              services={services}
              entities={entities}
              updateFiles={handleChangeFiles}
              wizzOnChange={onChange}
              wizzToggle={toggle}
              decimalScale={asset.SubAssetClassDecimalPlaces}
            />
          )}
          {tab === TabName.Structure && !services.fetchServiceGetIssuerType && (
            <StructureTab
              mode={mode}
              fields={asset}
              previousFields={previousAsset}
              services={services}
              entities={entities}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Structure && services.fetchServiceGetIssuerType && (
            <Structure2Tab
              mode={mode}
              fields={asset}
              previousFields={previousAsset}
              services={services}
              entities={entities}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Payments && !asset.Contracts && (
            <PaymentsTab
              mode={mode}
              assetId={id}
              asset={asset}
              services={services}
              assetPayments={getPropertySafe(asset, "Payments")}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Payments && asset.Contracts && (
            <ContractsTab
              mode={mode}
              assetId={id}
              decimalScale={asset.SubAssetClassDecimalPlaces}
              services={services}
              assetContracts={getPropertySafe(asset, "Contracts")}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Groups && (
            <GroupsTab
              mode={mode}
              assetId={id}
              services={services}
              assetGroups={getPropertySafe(asset, "Groups")}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Tax && (
            <TaxTab
              mode={mode}
              assetId={id}
              fields={previousAsset}
              services={services}
              assetTaxes={getPropertySafe(asset, "Taxes")}
              wizzOnChange={onChange}
              wizzToggle={toggle}
              role={role}
            />
          )}
          {tab === TabName.Sinonyms && (
            <SinonymslTab
              mode={mode}
              assetId={id}
              services={services}
              defaultId={getPropertySafe(asset, "AssetDefaultIdentifier")}
              assetSynonyms={getPropertySafe(asset, "Synonyms")}
              dataProviders={entities.dataProviders}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Currency && (
            <CurrencyTab
              mode={mode}
              assetId={id}
              services={services}
              currencies={entities.currencies}
              settleCurrencies={getPropertySafe(asset, "SettlementCurrencies")}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab === TabName.Quotes && (
            <QuotesTab
              mode={mode}
              assetId={id}
              services={services}
              fields={asset}
              currencies={entities.currencies}
              wizzOnChange={onChange}
              wizzToggle={toggle}
              decimalScale={asset.SubAssetClassDecimalPlaces}
            />
          )}
          {tab === TabName.Agencies && (
            <AgenciesTab
              mode={mode}
              assetId={id}
              services={services}
              currencies={entities.currencies}
              wizzOnChange={onChange}
              wizzToggle={toggle}
            />
          )}
          {tab == TabName.Portfolios && (
            <PortfoliosTab
              mode={mode}
              assetId={id}
              services={services}
              toggleOrder={toggleOrder}
              assetInfo={asset}
              decimalScale={asset.SubAssetClassDecimalPlaces}
              opsViewAccountName={opsViewAccountName}
            />
          )}
          {tab == TabName.Denominations && asset.AssetPhysicalDenomination && (
            <Denominations mode={mode} assetId={id} services={services} assetInfo={asset} />
          )}
          {tab == TabName.Fundamentals && (
            <FundamentalsTab mode={mode} assetInfo={asset} assetId={id} services={services} />
          )}

          {modals.message.open && <ModalMessage {...modals.message} toggle={() => toggle("message", {})} />}

          {modals.confirm.open && <ModalConfirm {...modals.confirm} toggle={() => toggle("confirm", {})} />}

          {modals.calculator.open && (
            <ModalCalculator
              {...modals.calculator}
              services={services}
              assetInformation={asset}
              toggle={() => toggle("calculator", {})}
              role={role}
            />
          )}
        </CardBody>
        {mode != WizzMode.View && (
          <CardFooter>
            {mode == WizzMode.New && role == "backoffice" && (
              <LaddaButton
                className="btn btn-ladda btn-info pl-3 pr-3 mr-2"
                loading={saving.save}
                disabled={saving.saveAndContinue}
                onClick={() => handleSave(false)}
                data-style={SLIDE_LEFT}
              >
                <i className="fa fa-floppy-o mr-1" aria-hidden="true" />
                Save and send to backoffice
              </LaddaButton>
            )}
            {(tab === TabName.General || tab === TabName.Structure) && (
              <LaddaButton
                className="btn btn-ladda btn-primary pl-3 pr-3"
                loading={saving.saveAndContinue}
                disabled={saving.save}
                onClick={() => handleSave(true)}
                data-style={SLIDE_LEFT}
              >
                <i className="fa fa-floppy-o mr-1" aria-hidden="true" />
                {mode == WizzMode.New ? "Save and continue" : "Save changes"}
              </LaddaButton>
            )}
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export const useEntities = (initial) => useReducer((state, newState) => ({ ...state, ...newState }), initial);

const getPropertySafe = (elem, key) => (elem ? elem[key] : null);

function mapKeysToUndefined(keys) {
  const result = {};
  Object.keys(keys).forEach((key) => (result[key] = undefined));
  return result;
}

export default Wizzard;
